import { createAsyncThunk } from '@reduxjs/toolkit';
import { SelectFromStatement } from 'pgsql-ast-parser';

import { AstActionsTypes, SetAstOfVisualisationPayload, SourceAstItemInterface, SourcesAstType } from 'store/reducers/ast/types';
import {
  removeAstOfVisualisationById,
  setAstOfVisualisation,
  setSlice,
  updateAstOfEnabledFilters,
  updateAstOfSources,
} from 'store/reducers/ast';
import { EnabledFiltersDependencyInterface } from 'store/reducers/filters/types';
import { initialAstStoreState } from 'store/reducers/ast/constants';
import { ModelFromItemType } from 'store/reducers/models/types';
import { generateFilterAstsFn, getAstFromSql } from 'utils/SQL/genereteAst';
import { getMapObject } from 'utils/utils';
import { AST } from 'types/ast';
import Snackbar from 'services/Snackbar';

export const setAstOfVisualisationActions = createAsyncThunk(
  AstActionsTypes.SET_AST_OF_VISUALISATION,
  (data: SetAstOfVisualisationPayload, { dispatch }) => {
    dispatch(setAstOfVisualisation(data));
  },
);

export const removeAstOfVisualisationActions = createAsyncThunk(
  AstActionsTypes.REMOVE_AST_OF_VISUALISATION,
  (visualisationId: string, { dispatch }) => {
    dispatch(removeAstOfVisualisationById(visualisationId));
  },
);

export const updateAstOfEnabledFiltersActions = createAsyncThunk(
  AstActionsTypes.UPDATE_AST_OF_ENABLED_FILTERS,
  (enabledFiltersDataDependency: EnabledFiltersDependencyInterface[], { dispatch }) => {
    const enabledFilters = enabledFiltersDataDependency.reduce((result, { fieldName, values, isRealData, id, type }) => {
      return isRealData && fieldName
        ? {
            ...result,
            [id]: generateFilterAstsFn({ fieldName, values, type }),
          }
        : result;
    }, {});

    dispatch(updateAstOfEnabledFilters(enabledFilters));
  },
);

export const updateAstOfSourcesActions = createAsyncThunk(
  AstActionsTypes.UPDATE_AST_OF_SOURCES,
  (modelsFrom: ModelFromItemType[], { dispatch }) => {
    let from: AST.FromFromParser = null;

    let astOfSources: SourcesAstType = {};

    try {
      const astOfSourcesAsArray: SourceAstItemInterface[] = modelsFrom.map(({ id, from: fromSection }) => {
        if (fromSection) {
          const parsedData = (getAstFromSql(`SELECT * ${fromSection}`) as SelectFromStatement) || {
            from: null,
          };

          from = parsedData.from as AST.FromFromParser;
        }

        return { id, ast: from };
      });

      astOfSources = getMapObject(astOfSourcesAsArray, 'id');
    } catch {
      Snackbar.show('Ошибка в секции FROM', 'error');
    } finally {
      dispatch(updateAstOfSources(astOfSources));
    }
  },
);

export const clearAstStore = createAsyncThunk(AstActionsTypes.CLEAR_AST_STORE, (_, { dispatch }) => {
  dispatch(setSlice(initialAstStoreState));
});
